import { UpdateQuoteInput } from '__generated__/GQL';
import { QUOTE_VALIDITY_DAYS_UNLIMITED } from 'features/Work/constants';
import { QuoteFormSchema } from 'features/Work/form/quoteForm.schema';
import { computeTasksDiff } from 'features/Work/utils';
import { formatInvoiceTask } from 'features/Work/utils/formatInvoiceTask';

import { RetrievedQuote } from '../../../hooks/queries/useRetrievedQuoteQuery';

export const formatUpdateMutationInput = (
  quote: QuoteFormSchema,
  retrievedQuote: RetrievedQuote,
): UpdateQuoteInput => {
  const sortedTasksWithoutTotals = quote.tasks.map(formatInvoiceTask);

  const { createdTasks, deletedTaskIds, updatedTasks } = computeTasksDiff(
    sortedTasksWithoutTotals,
    retrievedQuote.tasks,
  );

  // some fields cannot be updated and should not be passed as input, omit them
  return {
    clientId: quote.clientId,
    createdTasks: createdTasks.map(({ invoiceTaskId, ...task }) => task),
    deletedTaskIds,
    fiscalId: quote.fiscalId,
    lateFeePercentage: quote.lateFeePercentage,
    lateMaxDays: quote.lateMaxDays,
    quoteId: retrievedQuote.quoteId,
    settings: {
      displayTradeName: quote.settings.displayTradeName,
      issuerEmail: quote.settings.issuerEmail,
      legalMentions: quote.settings.legalMentions,
      quoteValidityDays:
        quote.settings.quoteValidityDays ?? QUOTE_VALIDITY_DAYS_UNLIMITED,
    },
    startAt: quote.startAt,
    subtitle: quote.subtitle,
    title: quote.title,
    updatedTasks,
  };
};
